export const getRankOnReorder = (columnCards, source, destination) => {
  let lowerRank;
  let higherRank;
  if (source.index > destination.index) {
    lowerRank =
      destination.index > 0 ? columnCards[destination.index - 1].rank : 0;
    higherRank = columnCards[destination.index].rank;
  } else {
    lowerRank = columnCards[destination.index].rank;
    higherRank =
      destination.index + 1 === columnCards.length
        ? columnCards[destination.index].rank + 2 * 10000
        : columnCards[destination.index + 1].rank;
  }

  return lowerRank + (higherRank - lowerRank) / 2;
};

export const getRankOnMove = (cards, destination) => {
  const destinationColumnCards = cards.filter(
    (card) => card.columnName === destination.droppableId
  );
  const lowerRank =
    destination.index > 0
      ? destinationColumnCards[destination.index - 1].rank
      : 0;
  const higherRank =
    // eslint-disable-next-line no-nested-ternary
    destinationColumnCards.length === 0
      ? 2 * 10000
      : destination.index === destinationColumnCards.length
      ? destinationColumnCards[destination.index - 1].rank + 2 * 10000
      : destinationColumnCards[destination.index].rank;

  return lowerRank + (higherRank - lowerRank) / 2;
};
